(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('RaciDialogController', RaciDialogController);

    RaciDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Raci', 'Area', 'Azione', 'CampagnaStatus'];

    function RaciDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Raci, Area, Azione, CampagnaStatus) {
        var vm = this;

        vm.raci = entity;
        vm.clear = clear;
        vm.save = save;
        vm.areas = Area.query();
        vm.aziones = Azione.query();
        vm.campagna_statuses = CampagnaStatus.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.raci.id !== null) {
                Raci.update(vm.raci, onSaveSuccess, onSaveError);
            } else {
                Raci.save(vm.raci, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:raciUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
